// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme/theme";
import Layout from "./components/layout/Layout";
import Home from "./pages/Home/Home";
import Partners from "./pages/Partners/Partners";
import About from "./pages/About/About";
import Innovation from "./pages/Innovation/Innovation";
import Contact from "./pages/Contact/Contact";
import Hardware from "./pages/Services/Hardware";
import MobileApp from "./pages/Services/MobileApp";
import WebApp from "./pages/Services/WebApp";
import HardwareCaseStudy from "./pages/CaseStudy/Hardware";
import SoftwareIntegration from "./pages/CaseStudy/SoftwareIntegration";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/innovation" element={<Innovation />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/services/hardware" element={<Hardware />} />
            <Route path="/services/software/mobile" element={<MobileApp />} />
            <Route path="/services/software/web" element={<WebApp />} />
            <Route
              path="/case-study/hardware"
              element={<HardwareCaseStudy />}
            />
            <Route
              path="/case-study/software-integration"
              element={<SoftwareIntegration />}
            />
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  );
}

export default App;
